import React, {useMemo} from 'react';
import TableAction from "../../strategyProject/tabs/TabResults/TableAction/TableAction";
import {Button} from "react-bootstrap";
import style from "../../strategyProject/tabs/TabResults/TabResults.module.less";
import {getActionsModel} from "../../../services/roles/projRoleStatus";

const ProjRegisterDataAction = ({ props, actions, userCtx, stratId,...rest }) => {
    const { id, reportStatus,status } = props;
    const {imageProps} = {...rest}
    const can = useMemo(
        () => getActionsModel(userCtx,reportStatus,status),
        [props, userCtx]
    );

    return (
        <>
            {
                can.See && <TableAction
                    imageProps={imageProps}
                    width={"350px"}
                    data={props.data}
                    actionsDisabled={!!can.See}
                >
                    {can.AddDecision && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.onExpertDecision(props)}
                            variant={"outline-success"}
                        >
                            Внести решение
                        </Button>
                    )}
                    {can.EditDecision && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.onExpertChangeDecision(props)}
                            variant={"outline-success"}
                        >
                            Изменить решение
                        </Button>
                    )}

                    {can.CloseProject && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.onCloseProj(props)}
                            variant={"outline-danger"}
                        >
                            Закрыть проект
                        </Button>
                    )}
                    {can.EditCloseProject && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.onChangeCloseProj(props)}
                            variant={"outline-danger"}
                        >
                            Изменить закрытие
                        </Button>
                    )}
                </TableAction>
            }
        </>
    );
};

export default ProjRegisterDataAction;